import DocumentationButton from "components/DocumentationButton";
import {
  EmptystatePuzzleColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import LinkButton from "ds/components/Button/LinkButton";

import { SpacesContext } from "../SpacesProvider";

type ContextsEmptyProps = {
  hasNoSearchResult?: boolean;
};

const ContextsEmpty = ({ hasNoSearchResult }: ContextsEmptyProps) => {
  const { hasEntityCreateAccess } = useTypedContext(SpacesContext);

  return (
    <>
      {hasNoSearchResult && (
        <EmptyState
          title="No results"
          caption="Try different filters."
          icon={EmptystateSearchNoResultsColored}
          announce
        />
      )}

      {!hasNoSearchResult && (
        <EmptyState
          title="You don’t have any contexts yet"
          icon={EmptystatePuzzleColored}
          caption="Contexts are collections of reusable configuration elements that can be shared between multiple Stacks. They make your life significantly easier when dealing with repetitive settings and/or credentials."
        >
          <Box gap="medium">
            <DocumentationButton
              to={getDocsUrl("/concepts/configuration/context")}
              label="Documentation"
            />
            {hasEntityCreateAccess && (
              <LinkButton variant="primary" to="/new/context">
                Create context
              </LinkButton>
            )}
          </Box>
        </EmptyState>
      )}
    </>
  );
};

export default ContextsEmpty;
